import { render, staticRenderFns } from "./SettingsBill.vue?vue&type=template&id=500461b8&"
import script from "./SettingsBill.vue?vue&type=script&lang=js&"
export * from "./SettingsBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports